//===================================
// Modal
//===================================

const ModalController = () => {
  let openModal;

  const init = () => {
    events();
  }

  const events = () => {
    const modalLinks = document.querySelectorAll('[data-open-modal]');

    modalLinks.forEach(link => link.addEventListener('click', handleClick));
  }

  const handleClick = (e) => {
    e.preventDefault();

    const modalId = e.currentTarget.getAttribute('data-open-modal');
    showModal(modalId);
  }

  const showModal = (modalId) => {
    const modal = document.querySelector(`${modalId}.modal`);
    if (!modal) return;

    openModal = modal;
    registerCloseEvents();
    modal.showModal();
    modal.dispatchEvent(new Event('open'));
  }

  const registerCloseEvents = () => {
    const modalCloseLinks = document.querySelectorAll('[data-close-modal]');

    openModal.addEventListener('click', onDialogClick);
    modalCloseLinks.forEach(link => link.addEventListener('click', onLinkClick));
  }

  const unregisterCloseEvents = () => {
    const modalCloseLinks = document.querySelectorAll('[data-close-modal]');

    openModal.removeEventListener('click', onDialogClick);
    modalCloseLinks.forEach(link => link.removeEventListener('click', onLinkClick));
  }

  const onDialogClick = (e) => {
    let rect = e.target.getBoundingClientRect();

    if (rect.left > e.clientX ||
      rect.right < e.clientX ||
      rect.top > e.clientY ||
      rect.bottom < e.clientY
    ) {
      e.preventDefault();
      closeModal();
    }
  }

  const onLinkClick = (e) => {
    e.preventDefault();
    closeModal();
  }

  const closeModal = () => {
    unregisterCloseEvents();
    openModal && openModal.close();

    openModal = null;
  }

  init();
}

document.addEventListener('DOMContentLoaded', () => {
  ModalController();
});